/* 转换层，包含API数据结构转换、针对UI展示的结构处理等
Adapter layer, includes API data structure conversion, structure processing for UI display, etc. */

import dayjs from 'dayjs';

import type { CreateShiftParams, GetAdminShiftListParams, GetStationShiftListParams, UpdateShiftParams } from './api';
import { TabStatus } from './const';

type AdminShiftListParams = {
  model: Record<string, any>;
}

type StationShiftListParams = {
  model: Record<string, any>;
  activeTab: typeof TabStatus[keyof typeof TabStatus];
}

export const transformAdminShiftListParams = (params: AdminShiftListParams): Omit<GetAdminShiftListParams, 'pageno' | 'count'> => {
  const { model } = params;
  const { slot_code, slot_time, cross_day, ...otherFields } = model;
  const [start_time, end_time] = slot_time || [];
  const newModel = { ...otherFields };
  const crossDay = /^\d+$/.test(cross_day) ? Number(cross_day) : 0;
  const endTimeHour = end_time ? dayjs(end_time * 1000).hour() : 0;
  const endTimeMinute = end_time ? dayjs(end_time * 1000).minute() : 0;
  // Ensure seconds are always '00'
  newModel.start_time = start_time ? dayjs(start_time * 1000).format('HH:mm') + ':00' : undefined;
  newModel.end_time = end_time ? `${endTimeHour + crossDay * 24}:`.padStart(3, '0') + `${endTimeMinute}`.padStart(2, '0') + ':00' : undefined ;

  return {
    ...newModel,
    slot_code,
  };
};

export const transformStationShiftListParams = (params: StationShiftListParams): Omit<GetStationShiftListParams, 'pageno' | 'count'> => {
  const { model, activeTab } = params;
  const { slot_code, slot_time, cross_day, ...otherFields } = model;
  const [start_time, end_time] = slot_time || [];
  const newModel = { ...otherFields };
  const crossDay = /^\d+$/.test(cross_day) ? Number(cross_day) : 0;
  const endTimeHour = end_time ? dayjs(end_time * 1000).hour() : 0;
  const endTimeMinute = end_time ? dayjs(end_time * 1000).minute() : 0;
  // Ensure seconds are always '00'
  newModel.start_time = start_time ? dayjs(start_time * 1000).format('HH:mm') + ':00' : undefined;
  newModel.end_time = end_time ? `${endTimeHour + crossDay * 24}:`.padStart(3, '0') + `${endTimeMinute}`.padStart(2, '0') + ':00' : undefined ;

  return {
    ...newModel,
    slot_code,
    status: activeTab === TabStatus.Enabled ? 1 : 0,
  };
};

export const transformCreateShiftParams = (params: Record<string, any>) => {
  const { start_time, end_time, cross_day, ...otherFields } = params;
  const newParams = { ...otherFields };
  const crossDay = /^\d+$/.test(cross_day) ? Number(cross_day) : 0;
  const endTimeHour = end_time ? dayjs(end_time).hour() : 0;
  const endTimeMinute = end_time ? dayjs(end_time).minute() : 0;

  newParams.start_time = start_time ? dayjs(start_time).format('HH:mm') + ':00' : undefined;
  newParams.end_time = end_time ? `${endTimeHour + crossDay * 24}:`.padStart(3, '0') +`${endTimeMinute}`.padStart(2, '0')+ ':00' : undefined;

  return newParams as CreateShiftParams;
};

export const transformUpdateShiftParams = (params: Record<string, any>) => {
  const { start_time, end_time, cross_day, ...otherFields } = params;
  const newParams = { ...otherFields };
  const crossDay = /^\d+$/.test(cross_day) ? Number(cross_day) : 0;
  const endTimeHour = end_time ? dayjs(end_time).hour() : 0;
  const endTimeMinute = end_time ? dayjs(end_time).minute() : 0;

  newParams.start_time = start_time ? dayjs(start_time).format('HH:mm') + ':00' : undefined;
  newParams.end_time = end_time ? `${endTimeHour + crossDay * 24}:`.padStart(3, '0') + `${endTimeMinute}`.padStart(2, '0') + ':00' : undefined;

  return newParams as UpdateShiftParams;
};
